<template>
  <v-dialog v-model="add" persistent permanent max-width="370" class="mx-1">
    <v-btn dark color="red lighten-1" small slot="activator">
      <v-icon>add</v-icon> <pre>SHKID_bot в VK</pre>
    </v-btn>
    <v-card>
      <v-toolbar flat>
        <span>Vk-bot</span>
        <v-spacer></v-spacer>
        <v-btn flat icon @click.native="clearData()">
          <v-icon>close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <v-text-field
          label="Введите цифровой id вашего аккаунта в ВК"
          v-model="accountId"
          type="number"
        ></v-text-field>
        <strong v-if="user">{{username}}</strong><br>
        <strong v-if="user.city && user.country">{{user.country.title}}, {{user.city.title}}</strong><br>
        <v-img v-if="user" :src="user.photo_200_orig"></v-img>
        <br>
        <v-btn small color="primary" class="ml-0" @click="fetchUser()" :disabled="!validAccountId">Найти пользователя</v-btn>
        <v-checkbox v-if="user" v-model="acceptAccount">
          <template v-slot:label>
            <div>
              <small>Подтверждаю, что являюсь владельцем данного аккаунта</small>
            </div>
          </template>
        </v-checkbox>
        <v-checkbox v-model="acceptOfert">
          <template v-slot:label>
            <div>
              <small>Условия <a
                target="_blank"
                href="https://cds43.ru/storage/documents/1684938488_dogovor-oferta.pdf.pdf"
              >
                договора-оферты
              </a> прочитал(а) и принимаю</small>
            </div>
          </template>
        </v-checkbox>
        <v-checkbox v-model="acceptInstruction">
          <template v-slot:label>
            <div>
              <small>С <a
                target="_blank"
                href="/docs/Shkid_bot_vk.pdf"
              >
                инструкцией
              </a> по подключению ознакомлен(а)</small>
            </div>
          </template>
        </v-checkbox>
        <small>
          <b>После нажатия кнопки "Продолжить" диалог будет закрыт. Для доступа в чат-бот воспользуйтесь кнопкой "Перейти к боту" у подключенной подписки в VK</b>
        </small>
        <br><br>
        <strong v-if="destination" style="color:red" align-center>
          Аккаунт уже подключен
        </strong>
        <br>
        <small v-if="amount && !destination">
          Сумма к списанию: <strong style="color:red">{{ parseFloat(amount /100) }}</strong> руб. (за календарный день)
        </small>
        <br>
        <small v-if="amount && !destination && parseFloat(amount / 100) > parseFloat(profile.balance)">
          Недостаточно средств. Ваш баланс: <strong style="color:red">{{ profile.balance }}</strong> руб.
        </small>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" flat
          @click.native="clearData"
        >
          Отмена
        </v-btn>
        <v-btn color="primary" flat
          @click.native="addAccount"
          :disabled="!validAccountId || !userChecked || denied || destination !== null || !acceptOfert || !acceptInstruction || !acceptAccount"
        >
          <span>Продолжить</span>
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
// eslint-disable-next-line
import moment from 'moment'
const accountRe = /[0-9]{1,32}/g
export default {
  name: 'new-vk-dialog',
  props: ['profile'],
  data: () => ({
    destination: null,
    add: false,
    accountId: null,
    amount: null,
    tariff: null,
    denied: false,
    acceptOfert: false,
    acceptInstruction: false,
    acceptAccount: false,
    username: null,
    userChecked: false,
    user: {}
  }),
  methods: {
    async fetch () {
        const { destinations } = await this.$store.dispatch('sioRequest', {
          topic: 'destinations',
          pl: {}
        })
        const destination = destinations.filter(x => x.transport === 'vk' &&
        x.personid === this.profile.personid && x.address === this.accountId)[0]
        destination ? this.destination = destination : this.destination = null
        await this.fetchTariffs()
    },
    clearData () {
      this.add = false
      this.accountId = null
      this.username = null
      this.destination = null
      this.amount = null
      this.denied = false
      this.acceptOfert = false
      this.acceptInstruction = false
      this.acceptAccount = false
      this.user = {}
    },
    async fetchTariffs () {
      const { tariffs } = await this.$store.dispatch('sioRequest', {
        topic: 'fetch-tariffs',
        pl: {}
      })
      this.tariff = tariffs.filter(x => x.tariffid === this.profile.tariffid)[0]
    },
    async addAccount () {
      try {
        const { meta } = await this.$store.dispatch('sioRequest', {
          topic: 'vk-create-request',
          pl: {
            userid: this.accountId,
            amount: this.amount * (-1),
          }
        })
        this.$emit('added')
        this.clearData()
        this.$store.dispatch('snack', meta.msg)
      } catch (err) {
        this.$store.dispatch('snack', err)
      }
    },
    async calculateAmount () {
      this.amount = parseInt(Math.abs(this.tariff.costs.misc.vk))
      parseFloat(this.amount/100).toFixed(2) > parseFloat(this.profile.balance) ? this.denied = true : this.denied = false
    },
    async fetchUser () {
      try {
        const { user } = await this.$store.dispatch('sioRequest', {
          topic: 'fetch-vk-user',
          pl: {
            userid: this.accountId
          }
        })
        if (user && user.length > 0) {
          this.user = user[0]
          this.username = `${user[0].first_name} ${user[0].last_name}`
          this.userChecked = true
        } else {
          throw new Error('Пользователь ВК с данным идентификатором не найден')
        }
      } catch (err) {
        this.username = null
        this.userChecked = false
        this.$store.dispatch('snack', err)
      }
    }
  },
  computed: {
    validAccountId () {
      return accountRe.test(this.accountId)
    },
    today () {
      return moment().format('YYYY-MM-DD')
    }
  },
  watch: {
    async validAccountId (val) {
      console.log(val)
      if (val === true) {
        await this.fetch()
        this.calculateAmount()
      }
    }
  }
}
</script>

<style lang="css">
</style>
